import React from "react";

const HistoryModal = ({ open, onClose, savedHistory, loadHistoryItem, deleteHistoryItem }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
      <div className="bg-[#FFF7E6] border border-[#FFD8A6] p-8 rounded-2xl shadow-xl w-[500px] max-h-[70vh] overflow-y-auto">

        <h2 className="text-2xl font-bold text-[#5A3E2B] mb-4">History</h2>

        {savedHistory.length === 0 ? (
          <p className="text-[#7A6248]">No saved lists yet.</p>
        ) : (
          savedHistory.map((entry) => (
            <div
              key={entry.id}
              className="bg-white border border-[#FFE1B4] rounded-xl p-4 mb-3 shadow"
            >
              <p className="font-bold text-[#5A3E2B]">
                RM {entry.total.toFixed(2)}
              </p>

              <div className="flex gap-3 mt-2">
                <button
                  onClick={() => loadHistoryItem(entry)}
                  className="flex-1 py-2 bg-[#FF8C00] text-white rounded-lg"
                >
                  Load
                </button>

                <button
                  onClick={() => deleteHistoryItem(entry.id)}
                  className="flex-1 py-2 bg-red-400 text-white rounded-lg"
                >
                  Delete
                </button>
              </div>
            </div>
          ))
        )}

        <button
          onClick={onClose}
          className="w-full mt-4 py-2 rounded-xl bg-gray-200 text-[#5A3E2B]"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default HistoryModal;
